export default __webpack_public_path__ + "static/media/remove_Inventory.059732fd.svg";